import jwtAuthAxios from "../../services/jwtAuth";
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';


export const getRoles = createAsyncThunk("useraccess/getRoles", async() => {
    let token = await localStorage.getItem('auth_token');
    jwtAuthAxios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
    const response = await jwtAuthAxios.get('v1/roles');
    return response.data;
});

export const getUserAccess = createAsyncThunk("useraccess/getAll", async() => {
    let token = await localStorage.getItem('auth_token');
    jwtAuthAxios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
    const response = await jwtAuthAxios.get('v1/users');
    return response.data;
});

export const checkUsernameAvailability = createAsyncThunk("useraccess/checkUsernameAvailability", async (username) => {
    try {
        let token = await localStorage.getItem('auth_token');
        jwtAuthAxios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
        const response = await jwtAuthAxios.get(`v1/users/check-username/${username}`);

        return response.data;
    } catch (error) {
        // Handle errors if necessary
        throw error;
    }
});

export const getDefaultPassword = createAsyncThunk('userAccess/getDefaultPassword',async () => {
        try {
            const response = await jwtAuthAxios.get('v1/app-config/find/default-password');
            return response.data.value;
        } catch (error) {
            throw error;
        }
    }
);


export const getUserAccessById = createAsyncThunk("useraccess/getById", async(id) => {
    let token = await localStorage.getItem('auth_token');
    jwtAuthAxios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
    const response = await jwtAuthAxios.get(`v1/users/${id}`);
    // 
    return response.data;
});

export const deleteUserAccess = createAsyncThunk("useraccess/delete", async(id) => {
    let token = await localStorage.getItem('auth_token');
    jwtAuthAxios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
    await jwtAuthAxios.delete(`v1/users/${id}`);
    return id;
});

export const saveUserAccess = createAsyncThunk("useraccess/save", async(payload) => {
    let token = await localStorage.getItem('auth_token');
    jwtAuthAxios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
    const response = await jwtAuthAxios.post('v1/users',payload);
    return response.data;
});
export const updateUserAccess = createAsyncThunk("useraccess/update", async(request) => {
    let token = await localStorage.getItem('auth_token');
    jwtAuthAxios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
    const response = await jwtAuthAxios.put('v1/users',request);
    return response.data;
});

export const getUserAksesPageable = createAsyncThunk("useraccess/getUserAksesPageable",
    async({ page, pageSize, search }, thunkAPI) => {
        try{
            let token = await localStorage.getItem('auth_token');
            jwtAuthAxios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
            const searchParams = search === undefined ? "" : search;
            const url = `v1/users/pageable?page=${page}&size=${pageSize}&search=${searchParams}`
            const response = await jwtAuthAxios.get(url)
            return response.data
        } catch(response){
            throw response
        }
    });

export const updatePassword = createAsyncThunk("useraccess/updatePassword", async(payload) => {
    let token = await localStorage.getItem('auth_token');
    jwtAuthAxios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
    const response = await jwtAuthAxios.post('v1/users/update-password',payload);
    return response.data;
});

const initialState = {
    dataAllUserAkses:[],
    dataRoles:[],
    data:{},
    loadingRoles:false,
    listUser:[],
    listUserAccessById : [],
    defaultPassword: []
}

const useraccessSlice = createSlice({
    name:"useraccess",
    initialState: initialState,
    extraReducers: (builder) => {
        builder
            .addCase(getUserAksesPageable.pending, (state) => {
                state.loading = true;
            })
            .addCase(getUserAksesPageable.fulfilled, (state, action) => {
                state.dataAllUserAkses = action.payload;
                state.loading = false;
            })
            .addCase(getUserAksesPageable.rejected, (state, action) => {
                state.loading = false;
                console.error("Error during getMatkul:", action.error);
            })
        builder
            .addCase(getUserAccess.pending, (state) => {
                state.loading = true;
            })
            .addCase(getUserAccess.fulfilled, (state, action) => {
                state.listUser = action.payload;
                state.loading = false;
            })
            .addCase(getUserAccess.rejected, (state, action) => {
                state.loading = false;
                console.error("Error during getMatkul:", action.error);
            })
        builder
            .addCase(getUserAccessById.pending, (state) => {
                state.loading = true;
            })
            .addCase(getUserAccessById.fulfilled, (state, action) => {
                state.listUserAccessById = action.payload;
                state.loading = false;
            })
            .addCase(getUserAccessById.rejected, (state, action) => {
                state.loading = false;
                console.error("Error during getMatkul:", action.error);
            })
        builder
            .addCase(saveUserAccess.pending, (state) => {
                state.loading = true;
            })
            .addCase(saveUserAccess.fulfilled, (state, action) => {
                //state.listUserAccessById = action.payload;
                state.loading = false;
            })
            .addCase(saveUserAccess.rejected, (state, action) => {
                state.loading = false;
                console.error("Error during getMatkul:", action.error);
            })
        builder
            .addCase(deleteUserAccess.pending, (state) => {
                state.loading = true;
            })
            .addCase(deleteUserAccess.fulfilled, (state, action) => {
                //state.listUserAccessById = action.payload;
                state.loading = false;
            })
            .addCase(deleteUserAccess.rejected, (state, action) => {
                state.loading = false;
                console.error("Error during getMatkul:", action.error);
            })
        builder
            .addCase(updateUserAccess.pending, (state) => {
                state.loading = true;
            })
            .addCase(updateUserAccess.fulfilled, (state, action) => {
                //state.listUserAccessById = action.payload;
                state.loading = false;
            })
            .addCase(updateUserAccess.rejected, (state, action) => {
                state.loading = false;
                console.error("Error during getMatkul:", action.error);
            })
        builder
            .addCase(checkUsernameAvailability.pending, (state) => {
                state.loading = true;
            })
            .addCase(checkUsernameAvailability.fulfilled, (state, action) => {
                //state.listUserAccessById = action.payload;
                state.loading = false;
            })
            .addCase(checkUsernameAvailability.rejected, (state, action) => {
                state.loading = false;
                console.error("Error during getMatkul:", action.error);
            })
        builder
            .addCase(getDefaultPassword.pending, (state) => {
                state.loading = true;
            })
            .addCase(getDefaultPassword.fulfilled, (state, action) => {
                state.defaultPassword = action.payload;
                state.loading = false;
            })
            .addCase(getDefaultPassword.rejected, (state, action) => {
                state.loading = false;
                console.error("Error during getMatkul:", action.error);
            })
        builder
            .addCase(getRoles.pending, (state) => {
                state.loadingRoles = true;
            })
            .addCase(getRoles.fulfilled, (state, action) => {
                state.dataRoles = action.payload;
                state.loadingRoles = false;
            })
            .addCase(getRoles.rejected, (state, action) => {
                state.loadingRoles = false;
                console.error("Error during getMatkul:", action.error);
            })
        builder
            .addCase(updatePassword.pending, (state) => {
                state.loadingRoles = true;
            })
            .addCase(updatePassword.fulfilled, (state, action) => {
                state.data = action.payload;
                state.loadingRoles = false;
            })
            .addCase(updatePassword.rejected, (state, action) => {
                state.loadingRoles = false;
                console.error("Error during getMatkul:", action.error);
            })
    }
})
export const selectUser = (state) => state.useraccess;
export default useraccessSlice.reducer;